import { UserGroupClient } from '@frontend/group/api';
import { GroupMember, IGroup } from '@frontend/group/types';
import { useModals } from '@frontend/modal';
import { useCallback, useEffect, useState } from 'react';

export interface UserGroupCardProps {
    entity_id: string;
}

export const useUserGroupCard = (props: UserGroupCardProps) => {
    const { openModal } = useModals();
    const [groups, setGroups] = useState<IGroup[]>([]);
    const [members, setMembers] = useState<GroupMember[]>([]);

    const fetchGroups = useCallback(async () => {
        UserGroupClient.fetchUserGroupMembers({ entity_id: props.entity_id }).then((members) => {
            setMembers(members.results);
            const groupPromises = members.results.map((member) => UserGroupClient.fetchUserGroup(member.account_id, member.group_id).then((group) => group));
            Promise.all(groupPromises).then((fetchedGroups) => {
                setGroups(fetchedGroups);
            });
        });
    }, [props.entity_id]);

    useEffect(() => {
        fetchGroups();
    }, [fetchGroups]);

    return {
        openModal,
        groups,
        members,
        fetchGroups
    };
};
